module.exports = __webpack_public_path__ + "static/media/icon.e886f956.svg";